import priceBalancer from '../lib/stakePriceBalancer';
/**
 * @typedef {number} SLOT_FAMILY
 **/

export const SLOT_FAMILY_SINGLE = 'SLOT_FAMILY_SINGLE';
export const SLOT_FAMILY_MULTI =  'SLOT_FAMILY_MULTI';

export const BALANCING_FUNCTION_MAP = {
  price: priceBalancer,
  // ...
};

export const enum PrematchSignature {
  SUBSCRIBE_SIGNATURE = 'prematch_subscribe',
  MAIN_LINE_STAKE_SIGNATURE = 'prematch_main_line',
  MATCH_SIGNATURE = 'prematch_matchId',
}
